<template>
  <div class="batch-evolution-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="batch-container">
      <div class="batch-header">
        <div class="header-content">
          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-comment-dots title-icon"></i>
              Complementar em Lote
            </h1>

            <p class="page-subtitle">
              Selecione residentes e complemente evoluções em lote
            </p>
          </div>
        </div>
      </div>

      <div class="filters-section" v-if="$store.state.online">
        <div class="filters-card">
          <div class="filters-grid">
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-filter filter-icon"></i>
                Gênero
              </label>

              <v-select
                dense
                :items="genders"
                v-model="gender"
                outlined
                hide-details
                class="modern-select"
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-search filter-icon"></i>
                Pesquisar
              </label>

              <v-text-field
                dense
                placeholder="Nome do residente"
                outlined
                hide-details
                v-model="name"
                class="modern-input"
                @input="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-chart-line filter-icon"></i>
                Dependência
              </label>

              <v-select
                dense
                :items="typesFilterByGrau"
                v-model="degree_of_dependence_id"
                outlined
                hide-details
                class="modern-select"
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-bed filter-icon"></i>
                Ala/Setor
              </label>
              <v-select
                v-model="ward_or_sector"
                :items="beds"
                dense
                outlined
                hide-details
                class="modern-select"
                item-value="ward_or_sector"
                :item-text="
                  (value) => {
                    return value.ward_or_sector
                      ? `(ALA/Setor) ${value.ward_or_sector}`
                      : 'Não filtrar';
                  }
                "
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-user filter-icon"></i>
                Usuário (Fez evolução)
              </label>

              <v-select
                dense
                :items="users"
                v-model="user_evolution_id"
                outlined
                hide-details
                class="modern-select"
                item-value="id"
                item-text="name"
                @change="getResidents"
              />
            </div>
          </div>
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="content-card">
          <div class="select-all-section">
            <span class="select-all-label">
              <i class="fas fa-users mr-2"></i>
              Selecionar todos os residentes?
            </span>

            <b-form-group label="" class="mb-0">
              <b-form-radio-group
                v-model="selectAll"
                class="radio-group-modern"
              >
                <b-form-radio :value="true">SIM</b-form-radio>
                <b-form-radio :value="false">NÃO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="residents-grid">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="resident-checkbox-card"
              :class="{
                'resident-checkbox-card--selected': resident_ids.find(
                  (resident_id) => resident_id == resident.id
                ),
              }"
            >
              <b-form-checkbox
                :value="resident.id"
                :checked="
                  resident_ids.find((resident_id) => resident_id == resident.id)
                "
                @change="handleChangeCheckbox($event, resident.id)"
                size="lg"
                class="checkbox-modern"
              >
                <div class="resident-checkbox-info">
                  <img
                    class="resident-thumb"
                    :src="resident.photo_url"
                    :alt="resident.name"
                  />
                  <span class="resident-checkbox-name">
                    {{ resident.name }}
                  </span>
                </div>
              </b-form-checkbox>
            </div>
          </div>

          <div class="form-section mt-5">
            <div class="form-section-header">
              <i class="fas fa-tag mr-2"></i>
              <h6 class="form-section-title">Tipo de Evolução</h6>
            </div>

            <select v-model="type" class="modern-form-select">
              <option disabled value="">Selecione um tipo</option>

              <option
                v-for="evolution in evolution_types"
                :key="evolution.type"
                :value="evolution.type"
              >
                {{ evolution.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="action-bar-inline">
          <v-btn @click="getEvolutions()" class="btn-save">
            <i class="fas fa-check-double mr-2"></i>
            Complementar
          </v-btn>
        </div>

        <div v-if="evolutions.length == 0 && warning">
          <div class="alert-badge alert-warning mx-auto">
            <span>
              {{ warning }}
            </span>
          </div>
        </div>

        <div
          v-if="evolutions.length > 0"
          class="content-card evolution-form-card"
        >
          <div class="form-section">
            <div class="form-section-header">
              <i class="fas fa-align-left form-section-icon"></i>
              <h6 class="form-section-title">Texto Principal</h6>
            </div>
            <ChromeSpeechToTextTextarea
              rows="3"
              max-rows="10"
              v-model="main_text"
            />
          </div>

          <div class="form-section">
            <div class="form-section-header">
              <i class="fas fa-user-edit form-section-icon"></i>
              <h6 class="form-section-title">Evoluções por Residente</h6>
            </div>

            <div class="evolution-grid">
              <div
                v-for="evolution in evolutions"
                :key="evolution.id"
                class="evolution-item"
              >
                <div class="evolution-item-header">
                  <img
                    class="resident-thumb"
                    :src="evolution.photo_url"
                    :alt="evolution.name"
                  />
                  <span class="resident-checkbox-name">
                    {{ evolution.name }}
                  </span>
                </div>

                <ChromeSpeechToTextTextarea
                  disabled
                  rows="4"
                  max-rows="10"
                  v-model="evolution.text"
                />

                <div class="complement-section">
                  <span class="complement-label">
                    <i class="fas fa-plus-circle mr-1"></i>
                    Complemento
                  </span>
                  <ChromeSpeechToTextTextarea
                    rows="3"
                    max-rows="10"
                    v-model="evolution.complement"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ErrorsMessages :errors="errors" />

        <div v-if="evolutions.length > 0" class="footer-spacer"></div>
      </b-overlay>
    </div>

    <div v-if="evolutions.length > 0" class="sticky-footer">
      <div class="sticky-footer-inner">
        <confirmation-dialog
          headerClass="modal-header"
          :message-title="'ADICIONAR COMPLEMENTO?'"
          :message-body="`Deseja realmente adicionar complemento a essas evoluções?`"
          open-class="btn-save"
          open-left-icon="fa-check"
          :open-text="'Adicionar complemento'"
          @yes="complementary"
          :loading="loading"
          :disabled="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import toast from "../lib/ToastNotification";
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ChromeSpeechToTextTextarea from "../templates/Components/ChromeSpeechToTextTextarea";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import api from "../services/api";
import permission from "../lib/permission";
import {
  userData,
  getRestHomeSelectedFinancialAccount,
} from "../lib/functions";

export default {
  name: "BatchEvolutionsComplements",

  components: {
    NavBar,
    AuthBySessionExpired,
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  data() {
    return {
      user_evolution_id: null,

      selectAll: false,

      loading: false,

      user_profile_name: "",

      complementText: "",

      type: "",

      gender: "NONE",

      degree_of_dependence_id: "NONE",

      name: "",

      main_text: "",

      warning: "",

      ward_or_sector: "",

      evolution_types: [],

      beds: [],

      residents: [],

      resident_ids: [],

      errors: [],

      users: [],

      evolutions: [],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],
    };
  },

  watch: {
    selectAll() {
      if (this.selectAll) {
        this.resident_ids = this.residents.map(({ id }) => id);
      } else {
        this.resident_ids = [];
      }
    },

    main_text(value) {
      this.evolutions.forEach((evolution) => {
        evolution.complement = value;
      });
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    permission,

    retrieve() {
      let { user } = userData();

      this.user_profile_name = user.user_profile_name;

      this.getUsers();
      this.getResidents();
      this.getAllBeds();
      this.getEvolutionsType();
    },

    async getResidents() {
      try {
        this.loading = true;
        let {
          gender,
          name,
          degree_of_dependence_id,
          ward_or_sector,
          user_evolution_id,
        } = this;
        let params = {
          gender,
          name,
          degree_of_dependence_id,
          ward_or_sector,
          user_evolution_id,
        };
        const response = await api.get("/rest-home/residents/batch-evolution", {
          params,
        });
        const { error, errors, residents } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          for (let resident of residents) {
            resident.checked = true;
          }
          this.resident_ids = [];
          this.residents = residents;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUsers() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = [{ id: null, name: "TODOS" }, ...users];
      } catch (error) {
        console.log(error);
      }
    },

    async getEvolutions() {
      try {
        this.loading = true;

        const { resident_ids, type } = this;

        let params = { resident_ids, complement: 1, type };

        let response = await api.get("/rest-home/evolutions-batch", {
          params,
        });

        let { error, errors, evolutions } = response.data;

        this.warning = "";

        if (!error) {
          this.errors = [];

          if (evolutions.length == 0) {
            this.warning = "Nenhuma evolução encontrada";
          }

          for (let evolution of evolutions) {
            evolution.complement = null;
          }

          this.evolutions = evolutions;

          for (let evolution of evolutions) {
            if (evolution.evolution_complement) {
              evolution.text =
                evolution.text + "\n\n" + evolution.evolution_complement;
            }
          }
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async complementary() {
      try {
        this.loading = true;

        let { evolutions } = this;

        let response = null;

        for (let evolution of evolutions) {
          if (!evolution.complement) {
            this.errors = [
              "Preencha todos os complementos antes de continuar.",
            ];
            this.loading = false;
            return;
          }

          let params = { evolution };

          response = await api.post(
            "/rest-home/evolution/complement-batch",
            params
          );
        }

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.resident_ids = [];

          this.evolutions = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getAllBeds() {
      try {
        const response = await api.get("/rest-home/bed/ward");

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = [{ id: null, ward_or_sector: "" }, ...beds];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getEvolutionsType() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/evolutions/settings/actives"
        );

        let { evolution_types } = response.data;

        this.evolution_types = evolution_types;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    handleChangeCheckbox(checked, resident_id) {
      let { resident_ids } = this;

      if (checked) {
        let find = resident_ids.find((id) => id == resident_id);

        if (!find) {
          resident_ids.push(resident_id);
        }
      } else {
        resident_ids.map((id, key) => {
          if (id == resident_id) {
            resident_ids.splice(key, 1);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.batch-evolution-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.batch-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px 100px;
}

.batch-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.filters-section {
  margin-bottom: 24px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.filter-icon {
  color: #6b7280;
  font-size: 13px;
}

.content-card {
  background: white;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
  padding: 28px;
  margin-bottom: 20px;
}

.select-all-section {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-wrap: wrap;
}

.select-all-label {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.radio-group-modern >>> .custom-radio .custom-control-label {
  font-weight: 600;
  color: #374151;
  cursor: pointer;
}

.residents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 6px;
}

.resident-checkbox-card {
  background: #f8fafc;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  padding: 7px 10px;
  transition: all 0.15s ease;
  cursor: pointer;
}

.resident-checkbox-card:hover {
  border-color: #0f65b0;
  background: #eff6ff;
  box-shadow: 0 1px 6px rgba(15, 101, 176, 0.1);
}

.resident-checkbox-card--selected {
  border-color: #0f65b0;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 1px 6px rgba(15, 101, 176, 0.15);
}

.resident-checkbox-info {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-left: 2px;
}

.resident-thumb {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
  border: 1.5px solid #e5e7eb;
  flex-shrink: 0;
}

.resident-checkbox-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-bar-inline {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.evolution-form-card {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.form-section-icon {
  color: #0f65b0;
  font-size: 14px;
}

.form-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.evolution-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.evolution-item {
  background: #f8fafc;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: border-color 0.15s ease;
}

.evolution-item:focus-within {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.07);
}

.evolution-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.complement-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px dashed #cbd5e1;
}

.complement-label {
  font-size: 11px;
  font-weight: 700;
  color: #0f65b0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
}

.sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: white;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  padding: 12px 24px;
}

.sticky-footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-save-primary {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.2s ease !important;
}

.btn-save-primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 18px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-secondary {
  background: white !important;
  color: #1e884d !important;
  border: 2px solid #1e884d !important;
  border-radius: 10px !important;
  padding: 10px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
}

.btn-save-secondary:hover {
  background: #f0fdf4 !important;
  transform: translateY(-2px) !important;
}

.footer-spacer {
  height: 20px;
}

@media (max-width: 768px) {
  .batch-container {
    padding: 0 16px 100px;
  }

  .batch-header {
    padding: 16px 0;
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 24px;
  }

  .residents-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .select-all-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .action-bar-inline {
    justify-content: stretch;
  }

  .evolution-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .residents-grid {
    grid-template-columns: 1fr 1fr;
  }

  .evolution-grid {
    grid-template-columns: 1fr;
  }

  .action-bar-inline {
    flex-direction: column;
  }

  .btn-save-primary,
  .btn-save-secondary {
    width: 100% !important;
    justify-content: center !important;
  }

  .sticky-footer-inner {
    flex-direction: column;
  }
}

.batch-warning-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1.5px solid #f59e0b;
  border-radius: 8px;
  padding: 8px 16px;
  color: #92400e;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.12);
}

.batch-warning-badge i {
  color: #d97706;
  font-size: 12px;
  flex-shrink: 0;
}

.batch-warning-badge span {
  line-height: 1.4;
}

.batch-warning-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.batch-warning-badge--purple {
  background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
  border-color: #a78bfa;
  color: #4c1d95;
  box-shadow: 0 2px 6px rgba(167, 139, 250, 0.12);
}

.batch-warning-badge--purple i {
  color: #7c3aed;
}

.modern-form-select {
  width: 100%;
  padding: 11px 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  background: #f8fafc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  appearance: none;
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.modern-form-select:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}
</style>